<!--
  File : FindPassword.vue
  Reference: materialdesignicons.com
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="400">
        <v-toolbar class="elevation-0 mb--20" color="white">
          <v-row justify="center">
            <v-toolbar-title class="primary--text">비밀번호 찾기</v-toolbar-title>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              id="email"
              prepend-icon="mdi-account"
              type="email"
              label="아이디"
              @keyup.13.stop.prevent="next('mobile')"
              v-model="email"
            />
            <v-text-field
              id="mobile"
              prepend-icon="mdi-cellphone"
              type="tel"
              label="휴대폰번호"
              @keyup.13.stop.prevent="next()"
              v-model="mobile"
            />
            <v-text-field
              id="code"
              prepend-icon="mdi-lock-open-variant"
              type="number"
              label="인증번호"
              @keyup.13.stop.prevent="next()"
              v-model="code"
              v-if="id"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-left" cols="6">
            <a @click="login()" class="font-16">로그인</a>
          </v-col>
          <v-col class="text-right" cols="6">
            <v-btn v-if="!id" color="primary" class="elevation-0 font-14" @click.prevent="request()">인증번호요청</v-btn>
            <v-btn v-if="id" color="secondary" class="elevation-0 font-14" @click.prevent="verify()">확인</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  name: 'FindPassword',

  data () {
    return {
      email: '',
      mobile: '',
      id: null,
      code: ''
    }
  },

  props: {
    source: String,
  },

  methods: {
    next: function (type) {
      if (type == 'mobile' && this.email.trim().length >= 3) {
        document.getElementById('mobile').focus()
      }
      else if (this.mobile.trim().length >= 10) {
        this.request()
      }
    },

    request: function () {
      if (this.email.trim().length < 3) {
        alert('정확한 아이디를 입력해주세요.')
        document.getElementById('email').focus()
        return
      }
      if (this.mobile.trim().length < 10) {
        alert('정확한 휴대폰 번호를 입력해주세요.')
        document.getElementById('mobile').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('email', this.email)
      params.append('mobile', this.mobile)
      axios.post('/api/user/mobile', params, util.headers)
      .then(response => {
        if (response.data.error) {
          if (response.data.error == 'Not found') {
            alert(this.email + '은 없는 아이디입니다.')
          }
          else if (response.data.error == 'Wrong mobile') {
            alert('아이디와 휴대폰번호가 일치하지 않습니다.')
          }
          else {
            alert('네트워크 오류입니다. 관리자에게 문의해주세요.')
          }
        }
        else {
          this.id = response.data.id
          alert('휴대폰으로 인증번호가 1분 이내에 수신됩니다.')
        }
      })
    },

    verify: function () {
      if (this.code.trim().length != 6) {
        document.getElementById('code').focus()
        alert('6자리 인증번호를 입력하세요.')
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.id)
      params.append('code', this.code)
      axios.post('/api/user/verify', params, util.headers)
      .then(response => {
        if (response.data.error) {
          if (response.data.error == 'Wrong code') {
            alert('인증번호가 틀립니다. 다시 입력해주세요.')
          }
          else {
            alert('네트워크 오류입니다. 관리자에게 문의해주세요.')
          }
        }
        else {
          alert(this.email + '님의 임시비밀번호는 ' + response.data.password + ' 입니다.\n로그인 후 비밀번호를 꼭 변경하세요.')
          this.$router.push('/login')
        }
      })
    },

    login: function () {
      this.$router.push('/login')
    }
  },

  created () {
    console.clear()
    this.$emit('login', null)
  }
}
</script>

<style scoped>
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.mb--20 {
  margin-bottom: -20px;
}
</style>
